import BottomSheet from "../../../../../components/dashboards/components/shared/BottomSheet";

const EMPTY_ODDS = "--";

const MobileNFLOddsSheet = ({ isOpen, game, onClose }) => {
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title="Betting Odds" maxHeight="85vh">
      {!game ? (
        <div className="p-6 text-center text-sm text-white/60">Select a game to view odds.</div>
      ) : (
        <div className="p-4 space-y-5">
          <div className="flex items-center justify-center gap-6">
            <div className="text-center">
              {game?.teams?.away?.logo && (
                <img
                  src={game.teams.away.logo}
                  alt={game.teams.away.name}
                  className="w-12 h-12 object-contain mx-auto mb-2"
                />
              )}
              <p className="text-sm font-semibold text-white">{game?.teams?.away?.name || "Away Team"}</p>
              {game?.scores?.away?.total !== undefined && (
                <p className="text-xl font-bold text-white mt-1 tabular-nums">{game.scores.away.total}</p>
              )}
            </div>
            <div className="text-white/60 text-sm font-semibold">@</div>
            <div className="text-center">
              {game?.teams?.home?.logo && (
                <img
                  src={game.teams.home.logo}
                  alt={game.teams.home.name}
                  className="w-12 h-12 object-contain mx-auto mb-2"
                />
              )}
              <p className="text-sm font-semibold text-white">{game?.teams?.home?.name || "Home Team"}</p>
              {game?.scores?.home?.total !== undefined && (
                <p className="text-xl font-bold text-white mt-1 tabular-nums">{game.scores.home.total}</p>
              )}
            </div>
          </div>

          {[
            {
              title: "Point Spread",
              options: [
                { label: game?.teams?.away?.name || "Away", value: EMPTY_ODDS, odds: EMPTY_ODDS },
                { label: game?.teams?.home?.name || "Home", value: EMPTY_ODDS, odds: EMPTY_ODDS }
              ]
            },
            {
              title: "Money Line",
              options: [
                { label: game?.teams?.away?.name || "Away", value: EMPTY_ODDS, odds: EMPTY_ODDS },
                { label: game?.teams?.home?.name || "Home", value: EMPTY_ODDS, odds: EMPTY_ODDS }
              ]
            },
            {
              title: "Total Points",
              options: [
                { label: "Over", value: EMPTY_ODDS, odds: EMPTY_ODDS },
                { label: "Under", value: EMPTY_ODDS, odds: EMPTY_ODDS }
              ]
            }
          ].map((section) => (
            <div key={section.title} className="bg-white/[0.05] rounded-2xl p-4">
              <h3 className="text-sm font-semibold text-white/80 mb-3">{section.title}</h3>
              <div className="grid grid-cols-2 gap-3">
                {section.options.map((option) => (
                  <div key={`${section.title}-${option.label}`} className="bg-white/[0.06] rounded-xl p-3 text-center">
                    <p className="text-xs text-white/60 mb-1">{option.label}</p>
                    <p className="text-lg font-bold text-emerald-300">{option.value}</p>
                    <p className="text-xs text-white/50">{option.odds}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <p className="text-xs text-white/50 text-center pt-2">Odds data will appear here once provided by the API.</p>
        </div>
      )}
    </BottomSheet>
  );
};

export default MobileNFLOddsSheet;
